import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Camila', 'Mateo', 'Sofía', 'Lucas', 'Valentina', 'Martín', 'Isabella', 'Joaquín', 'Andrea', 'Diego'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 3000);
    // Then cycle every 12 seconds
    const intervalTimer = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl p-4 border border-stone-100 flex items-center space-x-3 transform transition-all duration-500 max-w-sm ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-203">
      <div className="bg-emerald-100 p-2 rounded-full flex-shrink-0" data-id="element-204">
        <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-205" />
      </div>
      <div data-id="element-206">
        <p className="text-sm text-stone-800 font-medium" data-id="element-207">
          <span className="font-bold" data-id="element-208">{currentBuyer.name}</span> de{' '}
          {currentBuyer.city}
        </p>
        <p className="text-xs text-stone-500" data-id="element-209">acaba de comprar esta guía</p>
      </div>
    </div>;
}